<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">Mettre en attente</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Ajouter un commentaire
                    <CustomTextArea
                        ref="comment"
                        class="stretch"
                        v-model="text"
                        placeholder="Décrivez la raison pour laquelle vous souhaitez passer l’objet en attente."
                    />
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="stretch default" @click="$emit('close')">
                    Mettre en attente
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal';
import CustomTextArea from '@/components/TextArea';
import CustomButton from '@/components/Button';

export default {
    props: ['value'],
    data() {
        return {
            text: this.value,
        };
    },
    watch: {
        text: function(newVal) {
            this.$emit('input', newVal);
        },
    },
    mounted() {
        this.$refs.comment.focus();
    },
    components: {
        Modal,
        CustomTextArea,
        CustomButton,
    },
};
</script>

<style lang="scss"></style>
